import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

export const isSameDay = (d1: Date, d2: Date): boolean =>
  d1.getDate() === d2.getDate() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getFullYear() === d2.getFullYear();

export const isSameMonth = (d1: Date, d2: Date): boolean =>
  d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();

export const getMonthDateRange = (
  date: Date,
): {
  startDate: Util.FullDateStr;
  endDate: Util.FullDateStr;
} => {
  const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return {
    startDate: commonDate.dateToFullDateString(startDate),
    endDate: commonDate.dateToFullDateString(endDate),
  };
};
